/**
 * @file: SectionHeader.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * Section header: a bold title with an optional right-aligned meta / action.
 */

import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { View } from 'react-native';
import { LD } from '../leadDetailKit';

export const SectionHeader = ({
  title,
  right,
}: {
  title: string;
  right?: React.ReactNode;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: rpx(24),
        marginBottom: rpx(10),
        marginHorizontal: rpx(2),
        minHeight: rpx(26),
      }}
    >
      <Typography.Text size={rpx(16)} color={LD.ink} bold>
        {title}
      </Typography.Text>
      {right}
    </View>
  );
};
